import { DialogContent } from '@mui/material';
import { FormInputField } from 'components/_commons/Form/Inputs';
import { CustomActionButtons } from 'components/_commons/Modals/_CustomActionButtons';
import { ModalFormField } from 'components/_commons/Modals/_ModalFormField';
import { ModalHeader } from 'components/_commons/Modals/_ModalHeader';
import { ModalProps } from 'hooks/ModalProvider';
import React, { useCallback, useState } from 'react';
import { FormContainer, useForm } from 'react-hook-form-mui';
import { translate } from 'utils';

export const AddAlertModal = ({
  onClose,
  onSubmit
}: ModalProps<any>) => {
  const formContext = useForm();
  const [isAlertSaving, setIsAlertSaving] = useState(false);

  const onSubmitModal = useCallback((submittedFields) => {
    onSubmit(submittedFields, setIsAlertSaving);
  }, [onSubmit]);

  return (
    <FormContainer
      formContext={formContext}
      FormProps={{ autoComplete: 'off', name: 'addAlertForm' }}
      onSuccess={onSubmitModal}
    >
      <ModalHeader onClose={onClose}>
        {translate('attestationFormRequest.alerts.modalCreate.title')}
      </ModalHeader>

      <DialogContent style={{ width: '50vw', marginTop: '30px' }}>
        <ModalFormField title={translate('attestationFormRequest.alerts.modalCreate.commentTitle')}>
          <FormInputField
            fullWidth
            label={translate('attestationFormRequest.alerts.modalCreate.commentLabel')}
            name="description"
            required
          />
        </ModalFormField>
      </DialogContent>

      <CustomActionButtons isSaving={isAlertSaving} onClose={onClose} />
    </FormContainer>
  );
};
